import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useHistory }  from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UISelect from 'components/selectbox/UISelect';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import codeDataStore from "common/codedata/store/CodeDataStore";
import UIUtils from "utils/UIUtils";
import paramStore from "common/page/store/ParamStore";
function ContentsContainer() {
  	const location = useLocation();
  	const receivedData = paramStore.getParam("adm6711");
	const history = useHistory();

	const [Biz_No,	SetBiz_No] = useState('');
	const [Biz_NM,	SetBiz_NM] = useState('');
	const [Firm_NM,	SetFirm_NM] = useState('');
	const [Bank_CD,	SetBank_CD] = useState('');
	const [Van_gb,	SetVAN_GB] = useState('');
	const [Firm_CD,	SetFirm_CD] = useState('');
	const [snd_id,	SetSND_ID] = useState('');
	const [rcv_id,	SetRCV_ID] = useState('');

    async function onClickRegist(event) {
    	event.preventDefault();
                			
		if (Biz_No === '' || Biz_NM === '' || Firm_NM === '' || Bank_CD === '' || Van_gb === '' || Firm_CD === '' || snd_id === '' || rcv_id === '') {
        	UIUtils.alert('*항목은 필수입력입니다.').then();
			return;
		}
		if(await UIUtils.confirm('저장하시겠습니까?')){		
	        const response:any = await CommonUtil.execute({
	            url:"adm_6711_c001",
	        	data: {
					"BIZ_NO": Biz_No,
					"BIZ_NM" : Biz_NM,
					"FIRM_NM" : Firm_NM,
					"BANK_CD" : Bank_CD,
					"VAN_GB" : Van_gb,
					"FIRM_CD" : Firm_CD,	
					"SND_ID" : snd_id,
					"RCV_ID" : rcv_id,							
				}
	       	})
	    	.then((response: any) => {
				UIUtils.alert('정상처리되었습니다.').then();
	            onClickList(event);
	    	}).catch((error) => {
	        	CommonUtil.showAxiosError(error);
	        	return;
	    	});        
		}
               

    };    		

    async function onClickList(event) {
    	event.preventDefault();		
	    let dataToSend = {};
	    // 다른 페이지로 이동하면서 데이터 전달
	    paramStore.setParam("adm6710", dataToSend);
	    
	    history.push({
	      pathname: 'adm6710',
	      state: { data: dataToSend }
	    });

    };    
      
	React.useEffect(() => {
    	codeDataStore.read("[BANK]");
        // @ts-ignore
    },[])
  
	return (
		<PageContainer>
			<LayoutAside />
			<div className="fww-con">
				<ul className="fww-brd">
					<li><Link to="/admin/">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">시스템관리</Link></li>
					<li><Link to="#">펌뱅킹관리</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">펌뱅킹정보 등록</h1>
					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">사업자번호</p>
								<div className="fo-value">
									<UIInput 
										className={'tf tf-md w375'}
										value={Biz_No}
										placeholder={Biz_No}
										valueChanged={(value) => SetBiz_No(value)}
										rules={["number"]}
									/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">사업장</p>
								<div className="fo-value">
									<UIInput
										className={'tf tf-md w100p'}
										value={Biz_NM} 
										placeholder={Biz_NM}
										valueChanged={(value) => SetBiz_NM(value)}
										rules={["required"]}
									/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">펌뱅킹 별칭</p>
								<div className="fo-value">
									<UIInput
										className={'tf tf-md w100p'}
										value={Firm_NM}
										placeholder={Firm_NM}
										valueChanged={(value) => SetFirm_NM(value)}
										rules={["required"]}
									/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">은행</p>
								<div className="fo-value">
									<div className="sl sl-md w375">
										<UISelect
								        	className=""
								        	firstName={"sel"}
								        	value={Bank_CD} 
								        	valueChanged={(value) => SetBank_CD(value)}
								        	codeData={codeDataStore.get("[BANK]")}
								      	/>
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">VAN구분</p>
								<div className="fo-value">
									<div className="sl sl-md 375">
										<UISelect
								        	className=""
								        	firstName={"sel"}
								        	value={Van_gb}
								        	valueChanged={(value) => SetVAN_GB(value)}
								        	codeData={[
												{ code: 'IVANC', name: 'VAN일반계좌'},
												{ code: 'IVANV', name: 'VAN가상계좌'}
											]}
								      	/>
									</div>									
								</div>
							</div>
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">기관코드</p>
								<div className="fo-value">
									<UIInput
										className={'tf tf-md w375'}
										value={Firm_CD}
										placeholder={Firm_CD}
										valueChanged={(value) => SetFirm_CD(value)}
										rules={["required"]}
									/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">송신 아이디</p>
								<div className="fo-value">
									<UIInput
										className={'tf tf-md w375'}
										value={snd_id}
										placeholder={snd_id}
										valueChanged={(value) => SetSND_ID(value)}
										rules={["required"]}
									/>
								</div>
							</div>
							<div className="fo-item fo-m-1-3  req">
								<p className="fo-key">수신 아이디</p>
								<div className="fo-value">
									<UIInput
										className={'tf tf-md w375'}
										value={rcv_id}
										placeholder={rcv_id}
										valueChanged={(value) => SetRCV_ID(value)}
										rules={["required"]}										
									/>
								</div>
							</div>
						</div> 
					</form>
					<div className="hz-root hz-right hz-gap5">
						<Button color="pri-o" size="sm" onClick={onClickRegist}>저장</Button>
						<Button color="gray-o" size="sm" onClick={onClickList}>목록</Button>
					</div>								
				</main>

			</div>
		</PageContainer>
	);
}
export default ContentsContainer;